import { render } from "./CentralClinician.vue?vue&type=template&id=420a78e4&ts=true"
import script from "./CentralClinician.ts?vue&type=script&lang=ts&external"
export * from "./CentralClinician.ts?vue&type=script&lang=ts&external"

import "./CentralClinician.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__